'use client';

import {CategoryMenu} from '@shared/Articles/ArticleCategory/CategoryMenu/CategoryMenu';
import {TilesWithBlog} from '@shared/Articles/ArticlesWithSelectionsView/parts/TilesWithBlog/TilesWithBlog';
import {TilesWithMain} from '@shared/Articles/ArticlesWithSelectionsView/parts/TilesWithMain/TilesWithMain';
import {retryPromise} from '@utils/retryPromise';
import dynamic from 'next/dynamic';

import {ArticlesMainInfo, DevBlogMainInfo} from '@strapi/types';
import {articleSelectionType} from '@strapi/types/ArticleMainInfo';
import {CategoriesType} from '@strapi/types/Categories';

import styles from './ArticlesWithSelectionsView.module.scss';

export const ArticlesWithSelectionsView = ({
  categories,
  currentCategoryUrl,
  categoryDescription,
  articlesInfo,
  basePath,
  handleArticleSelectionSwipe,
  handleArticleCardClick,
  handleCategoryItemClick,
}: {
  categories: CategoriesType[];
  currentCategoryUrl: string;
  categoryDescription?: string;
  articlesInfo: ArticlesMainInfo | DevBlogMainInfo;
  basePath: 'prostore' | 'blog';
  handleArticleSelectionSwipe: (
    selection: articleSelectionType,
    selectionNumber: number,
  ) => (direction: 'left' | 'right') => void;
  handleArticleCardClick: (
    compilationName: string,
    article_name: string,
  ) => void;
  handleCategoryItemClick?: (category_name: string) => void;
}) => {
  const LazyCarouselSwiper = dynamic(
    retryPromise(
      async () =>
        import(
          /* webpackChunkName: "ArticleSelectionCarousel" */ '@shared/Articles/ArticlesWithSelectionsView/parts/Carousel/Carousel'
        ),
    ),
    {ssr: false},
  );

  return (
    <>
      <h1 className={styles.title}>Блог RuStore: Интересное</h1>
      <CategoryMenu
        categories={categories}
        currentCategoryUrl={currentCategoryUrl}
        categoryDescription={categoryDescription}
        menuItemClickAnalytics={handleCategoryItemClick}
        basePath={basePath}
      />
      {articlesInfo.BlogSelections?.map((selection, index) => {
        switch (selection.selectionType) {
          case 'tiles_with_main':
            return (
              <TilesWithMain
                key={index}
                selection={selection}
                handleArticleCardClick={handleArticleCardClick}
                basePath={basePath}
              />
            );
          case 'tiles_with_blog':
            return (
              <TilesWithBlog
                key={index}
                selection={selection}
                handleArticleCardClick={handleArticleCardClick}
                basePath={basePath}
              />
            );
          case 'carousel':
            return (
              <LazyCarouselSwiper
                key={index}
                selection={selection}
                onSwipe={handleArticleSelectionSwipe}
                selectionNum={index + 1}
                handleArticleCardClick={handleArticleCardClick}
                basePath={basePath}
              />
            );
          default:
            return null;
        }
      })}
      <div className={styles.footnote} data-testid={'prostore_page_footnote'}>
        {articlesInfo.articlesFootnote}
      </div>
    </>
  );
};
